import "../styles/app.scss"

(function(){
    console.log( "Hello !" )
})